/**
 * Door home settings extraction - extracted to break circular dependency
 * between mergeSettingsSet.ts and getMergedDoorSettings.ts
 */
import type { HomeSettings } from "building-types/settings/homeSettings";
import type { DoorHomeSettings } from "./mergedDoorSettings";

export function getDoorHomeSettings(homeSettings: HomeSettings): DoorHomeSettings {
  return {
    door: homeSettings.door,
    awning: homeSettings.awning,
    doorFraming: homeSettings.doorFraming,
    doorWrapping: homeSettings.doorWrapping,
    exteriorDoorCasing: homeSettings.exteriorDoorCasing,
    interiorDoorCasing: homeSettings.interiorDoorCasing,
  };
}
